export const userRoleLabels = {
  SUPERUSER: "Superusuário",
  ADMIN: "Administrador",
  USER: "Usuário",
  API_USER: "API",
  RESTRICTED_USER: "Usuário restrito",
};

export const userRoleOptions = Object.keys(userRoleLabels).map(value => ({
  value,
  label: userRoleLabels[value],
}));

// An admin cannot assign admin/superuser; a superuser may assign anything. The
// edited user's current role is always offered so it can be kept (e.g. an admin
// editing itself keeps "Administrador").
export const roleOptionsFor = (actingRole, currentRole) => {
  const base = actingRole === "SUPERUSER"
    ? userRoleOptions
    : userRoleOptions.filter(option => option.value !== "SUPERUSER" && option.value !== "ADMIN");

  if (currentRole && !base.some(option => option.value === currentRole)) {
    const current = userRoleOptions.find(option => option.value === currentRole);
    if (current) return [...base, current];
  }

  return base;
};
